/* src/app/main/matching/wizard/steps/records-list/matching-records.component.scss */
.form-component {
  font-family:
    "Segoe UI",
    Tahoma,
    Geneva,
    Verdana,
    sans-serif;
  margin: 0 auto;
  padding: 20px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.form-component .title-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  border-bottom: 2px solid #4a90e2;
  padding-bottom: 8px;
}
.form-component .title-header h3 {
  color: #2c3e50;
  margin: 0;
  font-size: 22px;
  font-weight: 600;
}
.form-component .title-header .title-buttons {
  display: flex;
  gap: 8px;
}
.form-component .title-header .title-buttons .title-button {
  flex: 1;
  min-width: 90px;
  padding: 6px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #ffffff;
  color: #333;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.form-component .title-header .title-buttons .title-button:hover {
  background: #f5f5f5;
  border-color: #999;
}
.form-component .title-header .title-buttons .title-button:active {
  background: #e8e8e8;
}
.form-component .title-header .title-buttons .title-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.form-component h4 {
  color: #333;
  margin-bottom: 12px;
  font-size: 18px;
}
.form-component .legend {
  flex-basis: 100%;
  max-width: 400px;
  margin-top: 10px !important;
  padding: 10px 16px;
  background:
    linear-gradient(
      135deg,
      #f8f9fa 0%,
      #ffffff 100%);
  border-radius: 6px;
  font-size: 14px !important;
  font-weight: 500;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.form-component .legend i {
  margin-left: 8px;
  margin-right: 4px;
}
.form-component .legend i.fa-link {
  color: #28a745;
}
.form-component .legend i.fa-user-check {
  color: #007bff;
}
.form-component .top-section {
  display: flex;
  align-items: stretch;
  gap: 20px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}
@media (max-width: 900px) {
  .form-component .top-section {
    flex-direction: column;
  }
}
.form-component .search-legend-container {
  flex: 0 1 auto;
  min-width: 250px;
  background:
    linear-gradient(
      135deg,
      #e8ecef 0%,
      #f0f3f5 100%);
  padding: 12px 16px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 0px;
  align-self: stretch;
}
.form-component .legend-container {
  display: flex;
  flex-direction: column;
}
.form-component .search-container {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  border: 1px solid #d5dbe2;
  border-radius: 6px;
  overflow: hidden;
  transition: all 0.3s ease;
  background: #ffffff;
  min-height: 40px;
}
.form-component .search-container:focus-within {
  border-color: #4a90e2;
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
}
.form-component .search-container .search-input {
  flex: 1;
  border: none;
  border-right: 1px solid #e0e0e0;
  padding: 0 12px;
  font-size: 15px;
  background: #ffffff;
  min-width: 0;
}
.form-component .search-container .search-input:focus {
  outline: none;
}
.form-component .search-container .dropdown-wrapper {
  display: flex;
  align-items: stretch;
  border-right: 1px solid #e0e0e0;
}
.form-component .search-container .dropdown-wrapper .filter-dropdown {
  border: none;
  padding: 0 8px;
  font-size: 14px;
  background: #f1f3f5;
  color: #495057;
  cursor: pointer;
  appearance: auto;
}
.form-component .search-container .dropdown-wrapper .filter-dropdown:focus {
  outline: none;
}
.form-component .search-container .search-button {
  border: none;
  background: #ffffff;
  color: #2f7be0;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
}
.form-component .search-container .search-button:hover {
  background: #eef4ff;
}
.form-component .search-container .search-button:active {
  background: #dfebff;
}
.form-component .search-container .search-button i {
  font-size: 16px;
}
.form-component .filter-section {
  flex: 1;
  min-width: 250px;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  background:
    linear-gradient(
      135deg,
      #e8ecef 0%,
      #f0f3f5 100%);
  padding: 12px 12px 12px 16px;
  border-radius: 6px;
  transition: all 0.3s ease;
  align-self: stretch;
}
.form-component .filter-section .filter-headline {
  color: #4a90e2;
  margin: 0 0 14px 0;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  background: rgba(74, 144, 226, 0.12);
  border-radius: 4px;
  display: inline-block;
}
.form-component .filter-section .checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 0px;
}
.form-component .filter-section .checkbox-group .checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #495057;
  font-size: 14px;
  white-space: nowrap;
  padding: 6px 0px 6px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  cursor: pointer;
}
.form-component .filter-section .checkbox-group .checkbox-label:hover {
  background: #ffffff;
}
.form-component .filter-section .checkbox-group .checkbox-label input[type=checkbox] {
  margin: 0;
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #4a90e2;
}
.form-component .data-display {
  flex: 1;
  align-self: stretch;
  min-width: 250px;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  padding: 12px 12px 12px 16px;
  background:
    linear-gradient(
      135deg,
      #e8ecef 0%,
      #f0f3f5 100%);
  border-radius: 6px;
}
.form-component .data-display .client-headline {
  color: #4a90e2;
  margin: 0 0 14px 0;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  background: rgba(74, 144, 226, 0.12);
  border-radius: 4px;
  display: inline-block;
}
.form-component .data-display .client-info-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.form-component .data-display .data-item {
  display: flex;
  align-items: baseline;
  white-space: nowrap;
}
.form-component .data-display .data-item .data-label {
  color: #6c757d;
  font-size: 14px;
  font-weight: 500;
}
.form-component .data-display .data-item .data-display-value {
  color: #4a90e2;
  font-weight: 600;
  margin-left: 8px;
  font-size: 15px;
}
.form-component .actions-section {
  flex: 0 0 auto;
  min-width: 180px;
  max-width: 200px;
  display: flex;
  flex-direction: column;
  background:
    linear-gradient(
      135deg,
      #e8ecef 0%,
      #f0f3f5 100%);
  padding: 12px 16px;
  border-radius: 6px;
  transition: all 0.3s ease;
  align-self: stretch;
}
.form-component .actions-section .actions-headline {
  color: #6c757d;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.form-component .actions-section .actions-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  justify-content: center;
}
.form-component .actions-section .actions-group .action-button {
  width: 100%;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  background:
    linear-gradient(
      135deg,
      #4a90e2 0%,
      #357abd 100%);
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(74, 144, 226, 0.3);
}
.form-component .actions-section .actions-group .action-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.4);
}
.form-component .actions-section .actions-group .action-button:active {
  transform: translateY(0);
}
.form-component .actions-section .actions-group .action-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}
.form-component .spacer-section {
  flex: 1;
  align-self: stretch;
  background:
    linear-gradient(
      135deg,
      #e8ecef 0%,
      #f0f3f5 100%);
  padding: 12px 16px;
  border-radius: 6px;
}
.form-component .button-group button {
  margin-right: 8px;
  margin-top: 8px;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  background:
    linear-gradient(
      135deg,
      #4a90e2 0%,
      #357abd 100%);
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(74, 144, 226, 0.3);
}
.form-component .button-group button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.4);
}
.form-component .button-group button:active {
  transform: translateY(0);
}
.form-component .button-group button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}
.data-preview-tables-wrapper {
  margin-top: 15px;
  width: 100%;
}
.data-preview-tables-wrapper .tables-container {
  display: flex;
  gap: 30px;
  width: 100%;
}
.data-preview-tables-wrapper .tables-container .table-section {
  flex: 1;
  min-width: 0;
  background: #ffffff;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}
.data-preview-tables-wrapper .tables-container .table-section:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}
.data-preview-tables-wrapper .tables-container .table-section h4 {
  margin-bottom: 4px;
  color: #2c3e50;
  font-size: 17px;
  font-weight: 600;
  padding-bottom: 8px;
  border-bottom: 2px solid #e9ecef;
}
.data-preview-tables-wrapper .tables-container .table-section .active-filter {
  font-size: 12px;
  color: #6c757d;
  margin-bottom: 10px;
}
.data-preview-tables-wrapper .tables-container .table-section .active-filter span {
  font-weight: 600;
  color: #4a90e2;
}
.data-preview-tables-wrapper .tables-container .table-section .no-data {
  padding: 15px;
  text-align: center;
  color: #666;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin-top: 10px;
}
.data-preview-tables-wrapper .tables-container .table-section ::ng-deep table {
  table-layout: fixed;
  width: 100%;
}
.data-preview-tables-wrapper .tables-container .table-section ::ng-deep table th,
.data-preview-tables-wrapper .tables-container .table-section ::ng-deep table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 8px;
}
.data-preview-tables-wrapper .tables-container .table-section ::ng-deep table th:nth-child(1),
.data-preview-tables-wrapper .tables-container .table-section ::ng-deep table td:nth-child(1) {
  width: 25px;
  min-width: 25px;
  max-width: 25px;
  text-align: center;
  padding: 4px !important;
  overflow: visible;
}
.data-preview-tables-wrapper .tables-container .table-section ::ng-deep table th:nth-child(2),
.data-preview-tables-wrapper .tables-container .table-section ::ng-deep table td:nth-child(2) {
  width: 32%;
  min-width: 150px;
}
.data-preview-tables-wrapper .tables-container .table-section ::ng-deep table th:nth-child(3),
.data-preview-tables-wrapper .tables-container .table-section ::ng-deep table td:nth-child(3) {
  width: 12%;
  min-width: 75px;
}
.data-preview-tables-wrapper .tables-container .table-section ::ng-deep table th:nth-child(4),
.data-preview-tables-wrapper .tables-container .table-section ::ng-deep table td:nth-child(4) {
  width: 17%;
  min-width: 110px;
}
.data-preview-tables-wrapper .tables-container .table-section ::ng-deep table th:nth-child(5),
.data-preview-tables-wrapper .tables-container .table-section ::ng-deep table td:nth-child(5) {
  width: 17%;
  min-width: 110px;
}
.data-preview-tables-wrapper .tables-container .table-section ::ng-deep table th:nth-child(6),
.data-preview-tables-wrapper .tables-container .table-section ::ng-deep table td:nth-child(6) {
  width: 14%;
  min-width: 90px;
  text-align: right;
}
.data-preview-tables-wrapper .tables-container .table-section ::ng-deep table th:nth-child(7),
.data-preview-tables-wrapper .tables-container .table-section ::ng-deep table td:nth-child(7) {
  width: 50px;
  min-width: 50px;
  max-width: 50px;
  overflow: visible;
}
@media (max-width: 992px) {
  .data-preview-tables-wrapper .tables-container {
    flex-direction: column;
    gap: 20px;
  }
}
/*# sourceMappingURL=matching-records.component-IL3ZTZMV.css.map */
